var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
export const Download = (_a) => {
    var { size, color = "#091E42", className } = _a, props = __rest(_a, ["size", "color", "className"]);
    return (React.createElement("svg", Object.assign({}, props, { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M12.123 15.4355L12.123 3.39453", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M15.0391 12.5078L12.1231 15.4358L9.20706 12.5078", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M16.756 8.12793H17.689C19.724 8.12793 21.373 9.77693 21.373 11.8129V16.6969C21.373 18.7269 19.728 20.3719 17.698 20.3719L6.55805 20.3719C4.52305 20.3719 2.87305 18.7219 2.87305 16.6869V11.8019C2.87305 9.77293 4.51905 8.12793 6.54805 8.12793L7.49005 8.12793", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=Download.js.map